/**
 * 判断是否为私有化环境
 */
export var isInPrivate = function isInPrivate() {
  return !!window.PRIVATE;
};